import { getDeviceType } from '@omni/kit/utilities/NativeHelpers';
import { useFocusEffect } from '@react-navigation/native';
import { useCallback } from 'react';
import { Platform } from 'react-native';
import Orientation from 'react-native-orientation-locker';

const debug = require('debug')('omni:media:hooks:useAutoRotate');

/**
 * Locks the orientation to portrait for handsets devices and
 * allow auto rotate for tablets.
 */
export default (): void => {
  if (Platform.OS !== 'web') {
    useFocusEffect(
      useCallback(() => {
        const fetchDeviceType = async () => {
          const deviceType = await getDeviceType();

          if (deviceType === 'handset') {
            debug('Locking orientation to portrait for small screens');
            Orientation.lockToPortrait();
          }
        };
        fetchDeviceType();

        return () => {
          debug('Unlocking orientation');
          Orientation.unlockAllOrientations();
        };
      }, [])
    );
  }
};
